import React, {useEffect, useRef, useState} from 'react';
import {useNavigate, useParams} from 'react-router-dom'
import axios from "axios";

const Popover = ({title, description, additional, close}) => {
    return (
        <div style={{
            backgroundColor: 'rgba(0, 0, 0, 0.80)',
            position: 'fixed',
            top: '0',
            left: '0',
            bottom: '0',
            right: '0',
            zIndex: 100
        }} onClick={close}>
            <div onClick={() => {
                return
            }} className={'row'} style={{maxHeight: '100%', position: 'relative', marginTop: 'auto', marginBottom: 'auto'}}>
                <div className={'column justify-center align-center'} style={{

                    minHeight: '30%',
                    maxHeight: '80%',
                    borderRadius: 25,
                    maxWidth: 1000,
                    width: 1000,
                    padding: 20,
                    backgroundColor: '#fff',
                    marginInline: "auto",
                    marginTop: '5%',
                    position: 'relative',
                    boxSizing: 'border-box'
                }}>
                    <span style={{wordWrap: 'break-word', marginLeft: '1%', marginRight: '10%',  width: '90%', textAlign: 'left', fontSize: 20}} dangerouslySetInnerHTML={{__html: description}}></span>
                    <div onClick={close} style={{cursor: 'pointer', position: 'absolute', top: '1%', right: '-5%'}}>
                        <svg width="31" height="28" viewBox="0 0 31 28" fill="none" xmlns="http://www.w3.org/2000/svg"  >
                            <path d="M18.68 13.64L30.6 28H23.8L15.28 17.76L6.8 28H0L11.88 13.64L0.6 -1.90735e-06H7.4L15.28 9.56L23.2 -1.90735e-06H30L18.68 13.64Z" fill="white"/>
                        </svg>
                    </div>
                </div>



            </div>
        </div>
    )
}
const Module = (props) => {
    const navigate = useNavigate()
    const params = useParams()
    const [story, setStory] = useState(null)
    const [currentStory, setCurrentStory] = useState(null)
    const [activeWord, setActiveWord] = useState(-1)
    const [activeWordColor, setActiveWordColor] = useState('#385FC1')
    const [nextWord, setNextWord] = useState(0)
    const [isMount, setIsMount] = useState(true)
    const [isPlaying, setIsPlaying] = useState(false)
    const [contentShow, setContentShow] = useState(false)
    const [testVisible, setTestVisible] = useState(false)
    const [haveAnswer, sethaveAnswer] = useState(-1)
    const [plaiyngTime, setPlayingTime] = useState(0)
    const [plaiyngInterval, setPlayingInterval] = useState(null)
    const [pauseTime, setPausedTime] = useState(0)
    const [lastCorrect, setLastCorrect] = useState(-1)
    const [currentSlide, setCurrentSlide] = useState(-1)
    const [currentDescription, setCurrentDescription] = useState(null)
    const [audio, setAudio] = useState(null)
    const [titleAudio, setTitleAudio] = useState(null)
    const boxRef = useRef()

    const URL_PREFIX = 'http://kitap.alsu.tatar/'

    useEffect(() => {
        console.log('useEffect [] ===>')
        axios.get('http://kitap.alsu.tatar/api/karaoke/list').then((response)=>{
            console.log(response.data.message);
            setStory(response.data.message)
            if (currentSlide<0 || !story) {
                setCurrentStory(response.data.message[params.idx])
                setCurrentSlide(params.idx)
            } else {
                setCurrentStory(story[currentSlide])
            }
        })
        console.log(params)

    }, [])

    useEffect(()=>{
        if (titleAudio) {
            titleAudio.play()
        }
    }, [titleAudio])

    useEffect(() => {
        if (currentSlide===-1) {
            return
        }
        setIsPlaying(false)
        setPausedTime(0)
        setActiveWord(-1)
        setNextWord(0)
        if (audio) {
            audio.pause()
        }
        if (titleAudio) {
            titleAudio.pause()
        }
        setAudio(new Audio(URL_PREFIX + story[currentSlide].audio.body))
        setTitleAudio(new Audio(URL_PREFIX + story[currentSlide].audio.title))
        clearInterval(plaiyngInterval)
    }, [currentSlide])

    function pause() {
        setPausedTime(plaiyngTime)
        audio.pause()
        clearInterval(plaiyngInterval)
        setIsPlaying(false)
    }

    useEffect(() => {
        let time = 0
        if (pauseTime > 0) {
            time = pauseTime
        }
        if (isPlaying) {
            let i = setInterval(() => {
                time += 500
                setPlayingTime(time)
            }, 500)
            setPlayingInterval(i)
        } else {
            clearInterval(plaiyngInterval)
            time = 0
        }
        return () => clearInterval(plaiyngInterval)
    }, [isPlaying])

    useEffect(() => {
        _onPlaybackStatusUpdate()
    }, [plaiyngTime])

    const _onPlaybackStatusUpdate = (status) => {
        if (currentSlide<0) {
            return
        }
        if (story[currentSlide].karaoke[nextWord]) {
            let nextW = story[currentSlide].karaoke.filter((item) => {
                return item.start < plaiyngTime;
            }).length;
            setActiveWord(nextW - 1);
            setNextWord(nextW)

        } else {

        }

    };

    function checkAnswer(idx) {
        sethaveAnswer(true)
        let answer = story[currentSlide].test[0].answers[idx]
        if (answer.correct) {
            return true
        }
        return false
    }

    const _getWords = () => {
        let text = []
        //console.log("_getWords", );
        let wordsss = "";
        // console.log(this.text);
        if (activeWord >= 0) {
            // console.log(this.state)
            wordsss = story[currentSlide].karaoke.map((item, i) => {
                return i <= activeWord ? (
                    <>
                        {item.description && (
                            <span onClick={() => {
                                setCurrentDescription(item.description)
                                pause()
                            }} style={{
                                color: activeWordColor,
                                borderBottomStyle: 'dotted',
                                borderBottomColor: activeWordColor,
                                fontWeight: 600,
                                fontSize:24,
                                borderBottomWidth: 3,
                                textAlign: 'center',
                                cursor: 'pointer',
                                borderBottomRightRadius: 3,}} key={i}>
                        {item.word}  {item.end && (<React.Fragment><br/></React.Fragment>)}
                    </span>
                        )}
                        {!item.description && (
                            <span style={{color: activeWordColor, fontWeight: 600, fontSize: 24}} key={i}>
                        {item.word} {item.end && (<React.Fragment><br/></React.Fragment>)}
                    </span>
                        )}
                    </>

                ) : (
                    <>
                        {item.description && (
                            <span onClick={() => {
                                setCurrentDescription(item.description)
                                pause()
                            }} key={i} style={{
                                color: "rgb(81,118,212)",
                                borderBottomStyle: 'dotted',
                                borderBottomColor: '#517694',
                                fontWeight: 600,
                                fontSize: 24,
                                borderBottomWidth: 3,
                                textAlign: 'center',
                                cursor: 'pointer',
                                borderBottomRightRadius: 3,
                            }}>
                            {item.word}  {item.end && (<React.Fragment><br/></React.Fragment>)}
                        </span>
                        )}
                        {!item.description && (
                            <span key={i} style={{color: "black", fontWeight: 600, fontSize: 24}}>
                            {item.word}  {item.end && (<React.Fragment><br/></React.Fragment>)}
                        </span>
                        )}
                    </>
                );
            });
        } else {
            //console.log(this.state)
            wordsss = story[currentSlide].karaoke.map((item, i) => {
                if (item.description) {
                    return (
                        <span onClick={() => {
                            setCurrentDescription(item.description)
                            pause()
                        }}
                              style={{
                                  color: "rgb(81,118,212)",
                                  borderBottomStyle: 'dotted',
                                  borderBottomColor: '#517694',
                                  borderBottomWidth: 3,
                                  fontWeight: 600,
                                  fontSize: 24,
                                  textAlign: 'center',
                                  cursor: 'pointer',
                                  borderBottomRightRadius: 3,
                              }} key={i}>
                                {item.word} {item.end && (<React.Fragment><br/></React.Fragment>)}
                            </span>
                    );
                } else {
                    return (
                        <span style={{color: "#000", fontWeight: 600, fontSize:24}} key={i}>
                        {item.word} {item.end && (<React.Fragment><br/></React.Fragment>)}
                    </span>
                    );
                }

            });
        }
        return wordsss;
    };

    const _playHello = async () => {
        console.log('Playing now!!!!')
    };

    function playSlide() {
        if (titleAudio) {
            titleAudio.pause();
        }
        audio.play()
        setIsPlaying(true)
    }

    function closePopover() {
        setCurrentDescription(null)
        playSlide()
    }

    function next() {
        console.log(story[currentSlide], story,  currentSlide)

        if (currentSlide===story.length-1) {
            audio.pause()
            titleAudio.pause()
            setTestVisible(false)
            setCurrentStory(story[0])
            setCurrentSlide(0)
            return
        }
        audio.pause()
        titleAudio.pause()
        setTestVisible(false)
        setCurrentStory(story[currentSlide*1+1])
        setCurrentSlide(currentSlide=>currentSlide*1+1)
        setLastCorrect(-1)

    }

    function prev() {
        setTestVisible(false)
        if (currentSlide===0) {
            audio.pause()
            titleAudio.pause()
            setCurrentStory(story[story.length-1])
            setCurrentSlide(story.length-1)
            return
        }
        audio.pause()
        titleAudio.pause()
        setCurrentStory(story[currentSlide-1])
        setCurrentSlide(currentSlide=>currentSlide-1)
        setLastCorrect(-1)
    }

    function openTestalar() {
        setTestVisible((testVisible)=>!testVisible);
        setTimeout(()=>{
            window.scrollTo({top: 8000, left: 0, behavior: 'smooth'})
        }, 200)
}

    const Answers = ({answers, showNext, answered}) => {
        const [selectedAnswer, setSelectedAnswer] = useState(-1)
        const [awaitComplete, setComplete] = useState(false)
        const [correct, setCorrect] = useState(null)
        useEffect(()=>{
            if (answered) {
                setCorrect(true)
                return;
            }
        }, [])
        useEffect(()=>{
            if (answered) {
                setCorrect(true)
                return;
            }
            setTimeout(()=>{
                if (selectedAnswer===-1 ) {
                    return
                }

                if (answers[selectedAnswer].correct && selectedAnswer >= 0) {
                    setTimeout(()=>{

                        showNext()
                        setCorrect(true)
                    }, 900)

                } else {
                    setComplete(true)
                    setTimeout(()=>{
                        setSelectedAnswer(-1)
                        setComplete(false)
                    }, 900)

                }
            }, 1000)
        }, [selectedAnswer])
        return (
            <>
                {answers.map((answer, idx) => (
                    <span key={'/kjjjub'+idx} onClick={() => {
                        if (selectedAnswer>=0) {return}
                        setSelectedAnswer(idx)
                    }} className={selectedAnswer>=0 ? 'story-answer-clicked' : 'story-answer'} style={{
                        marginTop: 1,
                        marginBottom: 1,
                        width: '96%',
                        textAlign: 'left',
                        paddingLeft: 40,
                        paddingBottom: 10,
                        paddingTop: 10,
                        backgroundColor: idx === selectedAnswer && !correct && !awaitComplete ? '#93A9E1' : correct && answer.correct ? '#72F890' : idx === selectedAnswer && awaitComplete && !correct && !answer.correct ? '#F87292' : '#DAE5FF',
                        color: '#2f2f2f',
                        fontWeight: 400
                    }}>{answer.answer}</span>
                ))}
            </>
        )
    }



    return (
        <>
            {currentSlide>-1 && (
                <div className={'column align-center'}
                     style={{width: '100%', backgroundColor: '#0048ff', minHeight: '98vh', top: 0}}>
                    <div className={'column justify-center align-center'} style={{width: '100%'}}>
                        <img src={URL_PREFIX + story[currentSlide].cover} width={'100%'}/>
                        <img onClick={playSlide} className={`${isPlaying ? 'hidden' : ''}`}
                             src={require('../../assets/playBtn.png')} width={96}
                             style={{position: 'absolute', cursor: "pointer"}}/>
                        <img onClick={pause} className={`${!isPlaying ? 'hidden' : ''}`}
                             src={require('../../assets/pauseBtn.png')} width={96}
                             style={{position: 'absolute', cursor: "pointer"}}/>

                    </div>
                    <div className={'row'}>
                        <div className={'column justify-start pt-16'}>
                            <img onClick={()=> {
                                audio.pause()
                                titleAudio.pause()
                                navigate('/')
                            }} src={require('../../assets/home.png')} width={90} style={{marginRight: -10, cursor: 'pointer'}} className={'story-button'}/>
                            <img src={require('../../assets/prev.png')} onClick={prev} width={90} style={{marginRight: -10, cursor: 'pointer', marginTop: 20}} className={'story-button'}/>
                        </div>
                        <div ref={boxRef} className={'column karaoke-box'}
                             style={{position: 'relative', width: 1000, minHeight: testVisible ? 900 : 650, backgroundColor: '#fff', zIndex: 99, paddingBottom:50, marginTop: -50}}>
                            <div>
                                <p style={{fontWeight: 400, fontSize: 24}}>{story[currentSlide].author}
                                </p>
                                <div style={{width: '100%', backgroundColor: '#DAE5FF', height: 5}}/>
                                <p className={'regular-text-700'} style={{fontSize: 32, color: 'rgb(81, 118, 212)'}}>{story[currentSlide].title}</p>

                            </div>
                            {audio && (
                                <div className={'row'} style={{width: '100%', height: 8}}>
                                    <div style={{width: `${audio.currentTime / audio.duration * 100}%`, backgroundColor: '#5176D4'}}/>
                                    <div style={{backgroundColor: '#BDCCF3', width: `${100 - audio.currentTime / audio.duration * 100}%`, height: 8}}/>
                                </div>
                            )}
                            <p style={{
                                lineHeight: '39px',
                                fontSize: 20,
                                fontWeight: 400,
                                textAlign: 'left',
                                wordWrap: 'break-word',
                                paddingLeft: 150,
                                paddingRight: 150
                            }}>
                                {_getWords()}

                            </p>

                            {testVisible && (
                                <div className={'column'} style={{width: '100%'}} >
                                    <div style={{textAlign: 'left', width: '100%', paddingLeft: 40}} className={'row justify-start'}>
                                        <svg width="41" height="41" viewBox="0 0 41 41" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M2.00144 2.00144C0.719939 3.28294 0 5.02102 0 6.83333V34.1667C0 35.979 0.719939 37.7171 2.00144 38.9986C3.28294 40.2801 5.02102 41 6.83333 41H34.1667C35.979 41 37.7171 40.2801 38.9986 38.9986C40.2801 37.7171 41 35.979 41 34.1667V6.83333C41 5.02102 40.2801 3.28294 38.9986 2.00144C37.7171 0.719939 35.979 0 34.1667 0H6.83333C5.02102 0 3.28294 0.719939 2.00144 2.00144ZM34.1667 4.55556H6.83333C6.22923 4.55556 5.64987 4.79554 5.2227 5.2227C4.79554 5.64987 4.55556 6.22923 4.55556 6.83333V34.1667C4.55556 34.7708 4.79554 35.3501 5.2227 35.7773C5.64987 36.2045 6.22923 36.4444 6.83333 36.4444H34.1667C34.7708 36.4444 35.3501 36.2045 35.7773 35.7773C36.2045 35.3501 36.4444 34.7708 36.4444 34.1667V6.83333C36.4444 6.22923 36.2045 5.64987 35.7773 5.2227C35.3501 4.79554 34.7708 4.55556 34.1667 4.55556ZM34.0213 13.0213H20.5V17.4894H34.0213V13.0213ZM34.0213 24.383H20.5V28.8511H34.0213V24.383ZM8.91033 20.0426H14.7052C15.2173 20.042 15.7083 19.8401 16.0705 19.4811C16.4326 19.1221 16.6363 18.6354 16.6368 18.1277V12.383C16.6363 11.8753 16.4326 11.3885 16.0705 11.0295C15.7083 10.6705 15.2173 10.4686 14.7052 10.4681H8.91033C8.3982 10.4686 7.90718 10.6705 7.54504 11.0295C7.18291 11.3885 6.97923 11.8753 6.97872 12.383V18.1277C6.97923 18.6354 7.18291 19.1221 7.54504 19.4811C7.90718 19.8401 8.3982 20.042 8.91033 20.0426ZM8.91033 31.4043H14.7052C15.2173 31.4037 15.7083 31.2018 16.0705 30.8428C16.4326 30.4838 16.6363 29.9971 16.6368 29.4894V23.7447C16.6363 23.237 16.4326 22.7502 16.0705 22.3912C15.7083 22.0322 15.2173 21.8303 14.7052 21.8298H8.91033C8.3982 21.8303 7.90718 22.0322 7.54504 22.3912C7.18291 22.7502 6.97923 23.237 6.97872 23.7447V29.4894C6.97923 29.9971 7.18291 30.4838 7.54504 30.8428C7.90718 31.2018 8.3982 31.4037 8.91033 31.4043Z" fill="#5176D4"/>
                                        </svg>
                                        <span style={{
                                            fontStyle: 'normal',
                                            fontWeight: 700,
                                            fontSize: 30,
                                            lineHeight: '148.02%',
                                            color: '#385FC1'
                                        }} className={'ml-3'}>Тестлар</span>
                                    </div>
                                    {story[currentSlide].test.map((question, qIdx)=>(
                                        <>
                                            <p className={' mt-10 mb-1'} style={{display: lastCorrect>=qIdx-1 ? 'flex' : 'none', textAlign: 'left', width: '95%', color: '#5176D4', fontSize: 20, fontWeight: 700}}>Copay {qIdx+1}</p>
                                            <div className={'column mt-1 mb-10'} style={{
                                                marginInline: 'auto' ,
                                                width: '95%',
                                                backgroundColor: '#ECECEC',
                                                height: 100,
                                                display: lastCorrect>=qIdx-1 ? 'flex' : 'none',
                                            }}>
                                                 <span style={{width: '96%', textAlign: 'left', paddingLeft: 40, paddingBottom: 10, paddingTop: 10, backgroundColor: '#5176D4', color: '#fff', fontWeight: 700, fontSize: 22
                                                 }}>{question.question}</span>
                                                <Answers answered={qIdx<=lastCorrect} answers={question.answers} showNext={()=> {
                                                    console.log('showNext', lastCorrect+1)
                                                    setLastCorrect(lastCorrect => lastCorrect + 1)
                                                    setTimeout(()=>{
                                                        window.scrollTo({top: 8000, left: 0, behavior: 'smooth'})
                                                    }, 500)
                                                }} />
                                            </div>
                                            </>


                                    ))}


                                </div>
                            )}
                        </div>
                        <div className={'column justify-start pt-16'}>
                            <img onClick={openTestalar} src={require('../../assets/testRightBtn.png')} width={90} style={{marginLeft: -10, cursor: 'pointer'}} className={'story-button'}/>
                            <img src={require('../../assets/next.png')} onClick={next} width={90} style={{marginLeft: -10, cursor: 'pointer', marginTop: 20}} className={'story-button'}/>
                        </div>
                    </div>
                    <div  style={{height: 3, width: '100%', backgroundColor: '#BDCCF3'}} className={'mt-5 mb-5'} ></div>
                    <span style={{textAlign: 'center', fontStyle: 'normal',
                        fontWeight: 400,
                        color: '#BDCCF3',
                        fontSize: 20,
                        lineHeight: '148.02%'}} className={'mb-3'}>ООО “Балачак”, 2022. Все права защищены</span>
                    {currentDescription && (
                        <Popover close={closePopover} description={currentDescription} />
                    )}
                    {contentShow && (
                        <div style={{
                            backgroundColor: 'rgba(0, 0, 0, 0.55)',
                            position: 'fixed',
                            width: '100%',
                            maxHeight: '100%',
                            top: '0',
                            left: '0',
                            bottom: '0',
                            right: '0',
                            zIndex: 200,
                            paddingTop: 50
                        }}>
                            <svg width="31" height="28" viewBox="0 0 31 28" fill="none" xmlns="http://www.w3.org/2000/svg" style={{position: 'absolute', cursor: 'pointer', top: '10%' , right: '15%'}} onClick={()=>{setContentShow(false)}}>
                                <path d="M18.68 13.64L30.6 28H23.8L15.28 17.76L6.8 28H0L11.88 13.64L0.6 -1.90735e-06H7.4L15.28 9.56L23.2 -1.90735e-06H30L18.68 13.64Z" fill="white"/>
                            </svg>
                            <div className={'column'} style={{maxWidth: '60%', marginInline: 'auto', borderRadius: 22,  justifyContent: 'center', backgroundColor: '#fff', maxHeight: '90vh', overflow: 'scroll'}}>
                                <div className={'mt-16 row justify-start pt-2 pb-2'} style={{width: '100%', backgroundColor: '#D9D9D9'}}>
                                    <span style={{textAlign: 'left', paddingLeft: 20}}>Произведения</span>
                                </div>
                                <div className={'row mt-4  mb-16 justify-center'} style={{overflow: 'scroll',backgroundColor: '#fff', flexWrap: 'wrap', minHeight: '50vh'}}>

                                    {story.map((item, idx) => (
                                        <div onClick={()=>{setCurrentSlide(idx); setContentShow(false)}} className={'mr-2 mb-3 row align-center'} style={{padding: 10, backgroundColor: '#F2F2F2', cursor: 'pointer', minWidth: '40%', maxHeight: 150}}>
                                            <img width={120} height={120} src={item.cover}  />
                                            <span className={'ml-4'}>{item.title}</span>
                                        </div>
                                    ))}
                                    {story.map((item, idx) => (
                                        <div onClick={()=>{setCurrentSlide(idx); setContentShow(false)}} className={'mr-2 mb-3 row align-center'} style={{padding: 10, backgroundColor: '#F2F2F2', cursor: 'pointer', minWidth: '40%', maxHeight: 150}}>
                                            <img width={120} height={120} src={item.cover}  />
                                            <span className={'ml-4'}>{item.title}</span>
                                        </div>
                                    ))}
                                    {story.map((item, idx) => (
                                        <div onClick={()=>{setCurrentSlide(idx); setContentShow(false)}} className={'mr-2 mb-3 row align-center'} style={{padding: 10, backgroundColor: '#F2F2F2', cursor: 'pointer', minWidth: '40%', maxHeight: 150}}>
                                            <img width={120} height={120} src={item.cover}  />
                                            <span className={'ml-4'}>{item.title}</span>
                                        </div>
                                    ))}
                                    {story.map((item, idx) => (
                                        <div onClick={()=>{setCurrentSlide(idx); setContentShow(false)}} className={'mr-2 mb-3 row align-center'} style={{padding: 10, backgroundColor: '#F2F2F2', cursor: 'pointer', minWidth: '40%', maxHeight: 150}}>
                                            <img width={120} height={120} src={item.cover}  />
                                            <span className={'ml-4'}>{item.title}</span>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            )}
        </>
    )
};

export default Module;
